import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      if (u.role === "admin") nav("/admin");
      else if (u.role === "wholesale" && u.status === "approved") nav("/account");
      else nav("/wholesale");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not sign in.");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-[520px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-24 fade-up">
      <p className="overline hidden">Sign in</p>
      <h1 className="font-serif font-light text-3xl md:text-4xl text-brand-dark mt-6 leading-tight">
        Welcome <span className="italic">back</span>.
      </h1>
      <form onSubmit={onSubmit} className="mt-10 space-y-6">
        <label className="block">
          <span className="overline block mb-1">Email</span>
          <input data-testid="login-email" required type="email" className="flushed-input" value={email} onChange={e => setEmail(e.target.value)} />
        </label>
        <label className="block">
          <div className="flex items-center justify-between mb-1">
            <span className="overline">Password</span>
            <Link
              data-testid="forgot-password-link"
              to="/forgot-password"
              className="text-xs text-brand-accent underline underline-offset-4"
            >
              Forgot?
            </Link>
          </div>
          <input data-testid="login-password" required type="password" className="flushed-input" value={password} onChange={e => setPassword(e.target.value)} />
        </label>
        <button data-testid="login-submit" disabled={busy} className="btn-primary mt-6">
          {busy ? "…" : "Sign in"}
        </button>
      </form>
      <p className="mt-10 text-sm text-brand-neutral">
        Applying for wholesale? <Link to="/wholesale" className="text-brand-accent">Apply here</Link>.
      </p>
    </div>
  );
}
